import React, { Component } from "react";
import './intersection-observer';

class Observer extends Component {
    constructor() {
        super();

        this.state = {
            isVisible: false
        };

        this.io = null;
        this.container = null;
    }

    componentDidMount() {
        var observer = ()=>{
            this.io = new window.IntersectionObserver(entries => {
                try {
                    entries.forEach(entry => {                  
                        if (!this.io) {
                            return;
                        }

                        this.setState({ 
                          isVisible: entry.isIntersecting 
                        });
                    });
                } catch(e) {
                    console.error(e);
                }
            }, {});

            this.io.observe(this.container);
        }

        if (window.IntersectionObserver) {
            observer();
        } else {
            System.import(/*webpackChunkName: "async"*/'./intersection-observer').then( () => {
                observer();
            }).catch(err => {
                console.log(err);
            });
        }
    }

    componentWillUnmount(){
        this.io = null;
        this.container = null;
    }

    render() {

        return ( 
            <div ref = { div => { this.container = div; }}>
            {
                Array.isArray(this.props.children) ? 
                this.props.children.map(child => child(this.state.isVisible)) :
                this.props.children(this.state.isVisible)
            } 
            </div>
        );
    }
}

export default Observer;


// WEBPACK FOOTER //
// ./js/lib/observer.js